var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"grid-our-products",attrs:{"align-center":""}},_vm._l((_vm.logosCompany),function(item,index){return _c('v-flex',{key:index,staticClass:"content-logo-company"},[_c('img',{staticClass:"icon-products",attrs:{"src":item.icon,"alt":""}})])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-063ad2f0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/logo-company.vue
// module id = 580
// module chunks = 0